import invariant from 'invariant';
import querystring from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getProductAvailability(params) {
    let { baseUrl, brandId, country, language, partNumber, options, clientId, clientSecret, uberToken } = params;

    invariant(baseUrl, 'baseUrl is a required param of getProductAvailability()');
    invariant(brandId, 'brandId is a required param of getProductAvailability()');
    invariant(country, 'country is a required param of getProductAvailability()');
    invariant(language, 'language is a required param of getProductAvailability()');
    invariant(partNumber, 'partNumber is a required param of getProductAvailability()');
    invariant(clientId, 'clientId is a required param of getProductAvailability()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const optionalQuery = options ? `?${querystring.stringify(options)}` : '';

    const concatUrl = `${baseUrl}search/resources/store/${localisedBrand}/product/${partNumber}/availability${optionalQuery}`;
    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getProductAvailability');
}
